import React from 'react';
import { Box, Typography } from '@material-ui/core';

/**
 * TEMPORARY placeholder — commit 8bea415 imports this file but it was never added,
 * which broke the admin build. It only provides the names that commit imports so
 * the app loads again; the real tiers editor (Abdul Jamil) replaces this file.
 *
 * The tiers are shown read-only. Nothing is validated here: the API checks
 * licence tiers itself on save (my-dq-api utils/pbdq_signup/licence_tiers.js).
 */

export const validateLicenceTiers = () => '';
export const validateLicenceTiersBySolution = () => '';
export const normalizeLicenceTiers = (input) => (input === null || input === undefined || input === '' ? [] : input);

const ReadOnlyTiers = ({ value, helperText }) => (
    <Box>
        <Typography variant="body2" component="pre" style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
            {JSON.stringify(value ?? null, null, 2)}
        </Typography>
        {helperText && <Typography variant="caption" color="textSecondary" display="block" style={{ marginTop: 4 }}>{helperText}</Typography>}
    </Box>
);

export const LicenceTiersBySolutionEditor = ReadOnlyTiers;
export default ReadOnlyTiers;
